import React from 'react'
import { Checkbox, TableCell, Typography } from "@mui/material"
import { useProductSettingsContext } from "../context/ProductSettingsContext";
import { SalesGeographyInMarketDatePicker } from "./SalesGeographyInMarketDatePicker";
import { SalesGeographyEndInMarketDatePicker } from "./SalesGeographyEndInMarketDatePicker";
import PropTypes from 'prop-types';

const enableInMarketDate = process.env.REACT_APP_ENABLE_IN_MARKET_DATE === 'true';
const enableSeasonalForecast = process.env.REACT_APP_ENABLE_SEASONAL_FORECAST === 'true';

export const DivisionRow = ({ row }) => {
    const { onRowSelectClick, isRowSelected, isRowCheckboxIndeterminate } = useProductSettingsContext();
    return (<React.Fragment>
        <TableCell padding="checkbox" className="Division">
            <Checkbox
                id={row.id}
                color="primary"
                indeterminate={isRowCheckboxIndeterminate(row)}
                checked={isRowSelected(row)}
                onChange={event => onRowSelectClick(row, event.target.checked)}
            />
        </TableCell>
        <TableCell colSpan={enableSeasonalForecast ? 8 : 7} className="Division">
            <Typography variant='h6'
                sx={{ marginLeft: '16px' }}>{row.id}</Typography>
        </TableCell>
        {enableInMarketDate && <SalesGeographyInMarketDatePicker row={row} className="Division" />}
        {enableInMarketDate && enableSeasonalForecast && <SalesGeographyEndInMarketDatePicker row={row} className="Division" />}
    </React.Fragment>)
}

DivisionRow.propTypes = {
    row: PropTypes.object,
}
